// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hEuvM{padding:15px 0}.ThMNi{padding:0}.A4Cjh{overflow:initial}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceTemplateSelector": `hEuvM`,
	"confirmationModal": `ThMNi`,
	"confirmationModalContent": `A4Cjh`
};
export default ___CSS_LOADER_EXPORT___;
